import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const MagicWandIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="M3.55 21.475L2.5 20.425L10.65 12.275L6.025 11.125L10.825 8.125L10.425 2.5L14.75 6.125L19.975 4.025L17.85 9.25L21.5 13.575L15.85 13.15L12.875 17.95L11.725 13.325L3.55 21.475ZM4.175 7.875L2.5 6.2L4.2 4.5L5.875 6.175L4.175 7.875ZM13.475 14.15L15.05 11.6L18.05 11.825L16.1 9.525L17.225 6.75L14.45 7.875L12.15 5.925L12.375 8.925L9.825 10.525L12.75 11.25L13.475 14.15ZM17.825 21.5L16.15 19.8L17.825 18.125L19.5 19.825L17.825 21.5Z" />
  </SvgIcon>
);
